﻿$(function () {
    var ex = JSON.parse($('#info_extension').val());

    console.log(ex);
    if (ex && ex.blocks && ex.blocks.length > 0) {
        var html = '';

        for (var i = 0; i < ex.blocks.length; i++) {
            var info = ex.blocks[i];
            if (info.content_ids) {
                html += '<div class="class" data-contents="' + info.content_ids.toString() + '">' + info.title + '</div>';
            }
        }
        $('.left').html(html);
    }

    $('.left .class').on('click', function () {
        if ($(this).hasClass('selected')) return;

        $('.left .class').removeClass('selected');
        $(this).addClass('selected');

        var id = $(this).data('contents');
        $.ajax({
            type: 'get',
            async: false,
            url: ROOT + '/a/contents?id=' + id,
            data: null,
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    console.log(data);
                    return;
                }

                var newlist = toListHtml(data);

                $('.middle .list').html(newlist);
            },
            error: function (data) {
                console.log(data);
            }
        });
    });
    $('.left .class:first').click();

    var rData = getColumnList('zhuanti', 1, 5);
    if (rData && rData.data && rData.data.length > 0) {
        var html = '';
        for (var i = 0; i < rData.data.length; i++) {
            var info = rData.data[i];
            html += '<div class="newest-item">\n' +
                '        <a href="' + info.url + '" class="newest-item-img">\n' +
                '            <img src="' + info.thumbnail_urls[0] + '?w=236&h=132&s=3" />\n' +
                '        </a>\n' +
                '        <a href="' + info.url + '" class="newest-item-title">' + info.title + '</a>\n' +
                '    </div>';
        }
        $('.right').html(html);
    }
});

function toListHtml(data) {
    var newlist = '';
    for (var i = 0; i < data.length; i++) {
        var info = data[i];
        if (info.thumbnail_urls === undefined || info.thumbnail_urls == null || info.thumbnail_urls == '')
            info.thumbnail_urls = [];

        var bottominfo = '';
        bottominfo += '<div class="news_info">';
        bottominfo += '<div class="user">' + info.author_nickname + '</div>';
        bottominfo += '<div class="time">' + info.publish_time + '</div>';
        bottominfo += '<div class="reply">';
        if (info.comment_count > 0)
            bottominfo += '<div class="reply_count">' + info.comment_count + '评论</div>';
        if (info.view_count > 0)
            bottominfo += '<div class="reply_count">' + info.view_count + '浏览</div>';
        bottominfo += '</div>';
        if (info.source)
            bottominfo += '<div class="source">来源: ' + info.source + '</div>';
        bottominfo += '</div>';

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (info.list_item_mode == 0 || info.thumbnail_urls.length == 0 || !info.thumbnail_urls[0]) { // 无图
            newlist += '<div class="newsInfo">';
            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.summary)
                newlist += info.summary;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist += '<img src="' + info.thumbnail_urls[0] + '?w=200&h=150&s=3' + '"/>';
            newlist += '</a>';
            newlist += '</div>';
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.summary)
                newlist += info.summary;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
        }
        newlist += '</div>';
        newlist += '<div class="dividing-line"></div>';
    }
    return newlist;
}
